import { scoreColor } from "@/lib/format";

export const ScoreRing = ({ value, size = 120, stroke = 8, label = "Account score" }) => {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const color = scoreColor(value);
  return (
    <div className="flex flex-col items-center gap-2" data-testid="score-ring">
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90">
          <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#f2f3ef" strokeWidth={stroke} />
          <circle
            cx={size / 2}
            cy={size / 2}
            r={r}
            fill="none"
            stroke={color}
            strokeWidth={stroke}
            strokeDasharray={c}
            strokeDashoffset={c * (1 - Math.min(value, 100) / 100)}
            strokeLinecap="butt"
            style={{ transition: "stroke-dashoffset 0.8s ease" }}
          />
        </svg>
        <div className="absolute inset-0 flex items-center justify-center">
          <span
            className="ss-mono font-semibold"
            style={{ fontSize: size * 0.34, color, lineHeight: 1 }}
            data-testid="score-ring-value"
          >
            {value}
          </span>
        </div>
      </div>
      {label && (
        <span className="ss-mono text-[10px] uppercase tracking-[0.18em] text-[color:var(--grey)]">{label}</span>
      )}
    </div>
  );
};
